import React, { useEffect, useState } from "react";
import loaderGif from "../../../../../../assets/images/loader.gif";
import { Tooltip } from "react-tooltip";
import "../Segments.css";

const SegmentsList = ({
  tableData,
  getSegments,
  updateStatus,
  search,
  deleteSegment,
  onSort,
  sortingColumn,
  sortingOrder,
  loader,
  selectedSegmentsRole,
}) => {
  const segmentsListData = (id) => {
    getSegments(id);
  };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="srno">Sr. No.</th>

              <th className="partner" onClick={() => onSort("country_name")}>
                Geo{" "}
                {sortingColumn === "country_name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="partner" onClick={() => onSort("parent_name")}>
                Parent Segment{" "}
                {sortingColumn === "parent_name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th className="partner" onClick={() => onSort("name")}>
                Name{" "}
                {sortingColumn === "name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th onClick={() => onSort("status")}>
                Status{" "}
                {sortingColumn === "status" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  ></i>
                ) : (
                  <i className="fas fa-sort"></i>
                )}
              </th>

              <th>Action</th>
            </tr>
          </thead>

          {!loader ? (
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData?.map((item, i) => {
                  const isParentSegment = item.parent_id === 0;
                  const canDelete =
                    storedUser?.email === "sudhanshu@tecreo.io" ||
                    !isParentSegment;

                  return (
                    <React.Fragment key={i}>
                      <tr>
                        <td>{i + 1}</td>
                        <td className="action">{item?.country_name}</td>
                        <td style={{ whiteSpace: "pre-line" }}>
                          {item?.parent_name?.trim() || "NA"}
                        </td>
                        <td style={{ whiteSpace: "pre-line" }}>{item?.name}</td>
                        <td className="text-center status">
                          <label className="custom-switch">
                            <input
                              disabled={!item?.segment_status}
                              type="checkbox"
                              checked={item?.status === 1}
                              onClick={() =>
                                updateStatus(item.id, item.status === 1 ? 0 : 1)
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td className="text-center status">
                          <div className="table-icons">
                            <i
                              className="fa-regular fa-pen-to-square green"
                              onClick={() => segmentsListData(item?.id)}
                            ></i>
                            {canDelete ? (
                              <i
                                className="fa-solid fa-trash-can red"
                                onClick={() => deleteSegment(item.id)}
                              ></i>
                            ) : (
                              <i
                                className="fa-solid fa-trash-can disabled-icon"
                                style={{ opacity: 0.3, cursor: "not-allowed" }}
                                title="You cannot delete a parent segment"
                              ></i>
                            )}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          ) : (
            <div className={`loader ${loader ? "show" : ""}`}>
              <label>
                <img src={loaderGif} alt="Loading..." />
              </label>
            </div>
          )}
        </table>
      </div>

      <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
    </>
  );
};

export default SegmentsList;
